export default{
  BloodDonation: 43,
  BloodRequest: 44,
  BloodCollection: 45,
  Crossmatch: 49,
  Reserve: 55
}
